import { Stack } from 'braid-design-system';
import type React from 'react';

type Props = Pick<React.ComponentProps<typeof Stack>, 'children'>;

const FormStack = ({ children }: Props) => (
  <Stack space={{ tablet: 'medium', desktop: 'medium', mobile: 'small' }}>
    {children}
  </Stack>
);

export default FormStack;
